import "../../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { Modal, Box } from "@mui/material";
import FormDetalle from './formDetalle/formDetalle';
import { InventariosDetFormState } from '../../../../context/inventariosDet/InventariosDetFormState';
import { InventariosDetContext } from '../../../../context/inventariosDet/InventariosDetContext';
import { formatRows } from "./configGrid/rows";
import { indice } from "../../../../components/DataGrid/indice";
import { getActionColumn } from "../../../../components/ActionesColumns/ActionColumns";
import CustomDataGrid from "../../../../components/DataGrid/CustomDataGrid"
import ConfirmDialog from "../../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { Paginator } from '../../../../components/paginator/Paginator';
import { getHeaders } from "./configGrid/headers";
import CircularProgress from "@mui/material/CircularProgress";
import { ArticulosDepositoState } from "../../../../context/articulosDeposito/ArticulosDepositoState";
import ModalObs from "./modalObs/modalObs";

export const DatatableDetalle = ({
  ajuid,
  depoid,
  arrayDetalle,
  addItem,
  getItem,
  updateItem,
  removeItem,
  isCabComplete,
  setIsDetalleFilled }) => {
  const contexto = useContext(InventariosDetContext);
  const { getInventariosDetPanelData } = contexto;
  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchArtId, setSearchArtId] = useState();
  const [searchArtDesc, setSearchArtDesc] = useState();
  // Ref de input
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  // Estado para el modal de detalle
  const [isModalDetalleOpen, setIsModalDetalleOpen] = useState(false);
  // Estado para un modal de observacion
  const [observacionSeleccionada, setObservacionSeleccionada] = useState("");
  const [modalObsOpen, setModalObsOpen] = useState(false);

  const nameData = "Articulo";
  const getData = getInventariosDetPanelData;

  useEffect(() => {
    fetchData();
  }, [ajuid, searchArtId, numPagina, filas, arrayDetalle ]);

  useEffect(() => {
    setIsDetalleFilled(arrayDetalle.length > 0);
  }, [arrayDetalle]);

  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);
    try {
      const { totalPage } = await fetchEntityData(
        getData,
        searchArtId || null,
        numPagina,
        filas,
        ajuid,
        setListaItems,
        setTotalItems,
        arrayDetalle
      );
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleClickEdit = async (id) => {
    try {
      setSelectedItem(id)
      handleOpenDetalleModal();
    } catch (error) {
      console.error("Error al obtener detalles:", error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteItem(selectedItem, arrayDetalle, removeItem);
      setSelectedItem(null);
      closeModal(); // deja que closeModal se encargue de recargar
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };

  const closeModal = async () => { 
    await fetchData();
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const handleOpenDetalleModal = () => {
    setIsModalDetalleOpen(true);
  };

  const handleCloseDetalleModal = async () => {
    await fetchData()
    setIsModalDetalleOpen(false);
    setSelectedItem(null);
  };


  const handleOpenModalObs = (texto) => {
    setObservacionSeleccionada(texto);
    setModalObsOpen(true);
  };

  const handleCloseModalObs = () => {
    setModalObsOpen(false);
  };
  const headers = getHeaders();

  const datosColum = useMemo(() => {
    const columnasVisibles = headers
      .filter((col) => !col.hidden)
      .map((col) => {
        if (col.field === "ajud_obs") {
          return {
            ...col,
            renderCell: (params) => {
              const texto = params.value;
              if (!texto) return null;

              return (
                <button
                  style={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    border: "none",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleOpenModalObs(texto)}
                >
                  Ver
                </button>
              );
            },
          };
        }
        return col;
      });

    const baseCols = indice(numPagina, filas).concat(columnasVisibles);

    const commonCols = ajuid
      ? baseCols
      : baseCols.concat(getActionColumn(handleClickEdit, openModal));

    return commonCols;
  }, [ajuid, numPagina, filas, headers]);

  const rows = useMemo(() => {
    return formatRows(listaItems);
  }, [listaItems]); 
  
  return (
    <>
      <div className="datatable">
        <div className="datatableTitle">
          {ajuid ? "Lista de los Articulos En El Inventario" : "Lista de los Articulos A Ajustar"}

          {(ajuid && arrayDetalle.length > 10) &&
            <>
              <FiltersGrid
                setSearchIDFilter={setSearchArtId}
                setSearchDescFilter={setSearchArtDesc}
              />
            </>
          }
          {(!ajuid && isCabComplete) &&
            <button
              type="button"
              className={`link ${!isCabComplete ? "disabled" : "enabled"}`}
              onClick={handleOpenDetalleModal}
            >
              Agregar
            </button>}

        </div>

        <>
          <div className="datagridWrapper">
            <CustomDataGrid
              rows={rows}  // Filtrar según la página actual
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems}
              onPageChange={(newPage) => setNumPagina(newPage)}  // Actualizar página
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);  // Resetear la página cuando se cambia el tamaño
              }}
              isLoading={isLoading}
              enablePagination={false}
            />
          </div>

          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}  // Total de páginas
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>
          <ConfirmDialog
            open={isModalOpen}
            onClose={closeModal}
            onConfirm={handleDelete}
            nameData={nameData}
          />
          <ErrorDialog
            open={isErrorDialogOpen}
            onClose={closeErrorDialog}
            errormessages={errorMessage}
          />
        </>

      </div>
      <InventariosDetFormState>
        <ArticulosDepositoState>
          <Modal
            open={isModalDetalleOpen}
            onClose={handleCloseDetalleModal}
            aria-labelledby="modal-form-detalle"
            aria-describedby="modal-form-detalle-descripcion"
            className="modalOferta"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: '450px',
                maxHeight: '80%', // Limitar la altura
                width: '100%', // El ancho ocupará el 100% hasta el máximo
                height: 'auto', // Deja que la altura dependa del contenido
                bgcolor: 'background.paper',
                borderRadius: '8px',
                boxShadow: 24,
                p: 4,
                overflowY: 'auto', // Habilitar scroll vertical

              }}
            >
              <FormDetalle
                iddet={selectedItem}
                ajuid={ajuid}
                depoid={depoid}
                arrayDetalle={arrayDetalle}
                addItem={addItem}
                updateItem={updateItem}
                getItem={getItem}
                removeItem={removeItem}
                closeModal={handleCloseDetalleModal}
                totalItems={totalItems}  // Cambié esto
              />
            </Box>
          </Modal>
        </ArticulosDepositoState>

      </InventariosDetFormState>
      {modalObsOpen && (
        <ModalObs
          onClose={handleCloseModalObs}
          title="Observación"
          children={
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <p>{observacionSeleccionada}</p>
            </div>
          }
        />
      )}
    </>
  );
};

export default DatatableDetalle;